import type { FortressOptions, Story, PaywallType } from "~types/types";

export function getFortressPropsFromStory(
    story: Story | null,
    paywallType: PaywallType
): FortressOptions {
    const {
        archived,
        brand,
        franchise,
        id,
        locale,
        metadata,
        premium,
        resourceType,
        revision,
        type,
        collections,
    } = story || {};

    return {
        articleInfo: {
            archived,
            brand,
            contentId: id || "",
            franchise,
            locale,
            metadata: {
                isMetered: metadata?.isMetered || false,
                cobrand: metadata?.cobrand,
                registrationWall: metadata?.registrationWall,
                collections: {
                    newsletterEntitlements: collections?.newsletterEntitlements
                        ? collections?.newsletterEntitlements
                        : null,
                },
            },
            premium,
            revision,
            resourceType: resourceType || "Story",
            type,
        },
        paywallData: {
            type: paywallType,
            selector: `article[data-story-id=${id}]`,
        },
    };
}
